// extracted by mini-css-extract-plugin
export default {"UnifiedHeader":"unified-header_UnifiedHeader__2jBWz"};